import React from 'react'
import {
  Col,
  Row,
  IconButton,
  ShareIosIcon,
  CashIcon,
  AddIcon,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import * as actionButtonsStyles from './index.css'
import MoreOptionsButton, { MoreOptionsItem } from './MoreOptionsButton'
import { useLocalizedContent } from '../../../../../hooks/useLocalizedContent'

export interface SmallScreenButtonsProps {
  displayShareButton?: boolean
  onShare?: () => void

  displayContributeButton?: boolean
  onContribute?: () => void

  displayCreateButton?: boolean
  onCreatePool?: () => void

  moreOptionsItems?: MoreOptionsItem[]
  onClickMoreOptions: () => void
}

const SmallScreenButtons = (props: SmallScreenButtonsProps) => {
  const { getContent } = useLocalizedContent()
  const {
    displayShareButton = false,
    onShare,
    onClickMoreOptions,
    displayContributeButton = false,
    onContribute,

    displayCreateButton = false,
    onCreatePool,

    moreOptionsItems,
  } = props

  return (
    <Row
      className={actionButtonsStyles.actionButtonsContainerSideBySideMobile}
      data-testid="smallActionButtons"
    >
      {displayShareButton && (
        <Col>
          <div className={actionButtonsStyles.alignTextCenter}>
            <IconButton
              className={actionButtonsStyles.sideBySideActionButton}
              buttonType="secondary"
              onClick={onShare}
              data-testid="smallScreenShareButton"
              svgIconComponent={ShareIosIcon}
              label={getContent('share.share')}
            >
              <Message id="share.share" />
            </IconButton>
          </div>
        </Col>
      )}
      {displayContributeButton && (
        <Col>
          <div className={actionButtonsStyles.alignTextCenter}>
            <IconButton
              className={actionButtonsStyles.sideBySideActionButton}
              buttonType="secondary"
              onClick={onContribute}
              data-testid="smallScreenContributeButton"
              svgIconComponent={CashIcon}
              label={getContent('flatProgress.contribute')}
            >
              <Message id="flatProgress.contribute" />
            </IconButton>
          </div>
        </Col>
      )}
      {displayCreateButton && (
        <Col>
          <div className={actionButtonsStyles.alignTextCenter}>
            <IconButton
              className={actionButtonsStyles.sideBySideActionButton}
              buttonType="secondary"
              onClick={onCreatePool}
              data-testid="smallScreenCreateButton"
              svgIconComponent={AddIcon}
              label={getContent('flatProgress.createPool')}
            >
              <Message id="flatProgress.createPool" />
            </IconButton>
          </div>
        </Col>
      )}
      {moreOptionsItems && moreOptionsItems.length > 0 && (
        <Col>
          <div className={actionButtonsStyles.alignTextCenter}>
            <MoreOptionsButton
              items={moreOptionsItems}
              displayLabel
              onClickMoreOptions={onClickMoreOptions}
            />
          </div>
        </Col>
      )}
    </Row>
  )
}

export default SmallScreenButtons
